import { render, staticRenderFns } from "./BusinessRegister.vue?vue&type=template&id=33354067&scoped=true&"
import script from "./BusinessRegister.vue?vue&type=script&lang=js&"
export * from "./BusinessRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33354067",
  null
  
)

export default component.exports